import React, { FC, ReactElement, useEffect } from 'react';
import {
  useConnectorUIState,
  useSourceUIState,
} from '../../../../uiState/contexts';

import SourceCustomFormFirstStep from './SourceCustomFormFirstStep';
import SourceCustomFormSecondStep from './SourceCustomFormSecondStep';
import { useAddConnector, useCustomSource } from '../../../../dataState';
import { buildForm } from './SourceCustomFormFirstStep/util/buildForm';

const SourceCustomForm: FC = (): ReactElement | null => {
  const [{ step }, setUIState] = useSourceUIState();
  const [{ chosenSource }] = useConnectorUIState();
  const [addConnectorData] = useAddConnector();
  const [, setCustomSource] = useCustomSource();

  useEffect(() => {
    const source = addConnectorData.sources?.find(
      (source) => source.preconfiguredSourceName === chosenSource?.name
    );
    const { domOwner } = addConnectorData;

    if (!source) {
      const form = buildForm({
        fields: chosenSource?.configuration?.fields,
        domOwner,
      });

      setCustomSource({
        form,
        availability: undefined,
        updateFrequency: undefined,
      });
      return;
    }

    const data = {
      form: (source as any).form,
      availability: source.availability,
      updateFrequency: source.updateFrequency,
    };

    setCustomSource(data);

    if (step) {
      setUIState((prev) => ({ ...prev, step: 0 }));
    }
  }, [addConnectorData, chosenSource]);

  if (step === 0) {
    return <SourceCustomFormFirstStep />;
  }

  if (step === 1) {
    return <SourceCustomFormSecondStep />;
  }

  return null;
};

export default SourceCustomForm;
